export const PRESSING_DONE_REQUEST = "PRESSING_DONE_REQUEST";
export const PRESSING_DONE_SUCCESS = "PRESSING_DONE_SUCCESS";
export const PRESSING_DONE_FAILED = "PRESSING_DONE_FAILED";